import i18n from '@/configs/i18n'
import vi from './vi.json'
import en from './en.json'

// Nạp locale của module InternalRating vào đúng namespace mà KHÔNG sửa configs/i18n:
//  - "rating"      -> namespace riêng của dialog/trang (useTranslation('rating'))
//  - "axios-error" -> bổ sung key lỗi để useMutationWithHandler dịch được (tAxiosError)
//  - "translation" -> bổ sung 'my-ratings' cho tiêu đề sidebar (t mặc định)
// deep=true (merge lồng nhau), overwrite=false (không đè key có sẵn của namespace dùng chung).
const bundles: Record<string, Record<string, Record<string, unknown>>> = {
    vi,
    en,
}

Object.entries(bundles).forEach(([lng, namespaces]) => {
    Object.entries(namespaces).forEach(([ns, resources]) => {
        i18n.addResourceBundle(lng, ns, resources, true, false)
    })
})
